import netsUserDetails from './nets-user-details';
import moduleConfig from './module-config';

export default angular
  .module('app.user-details', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsUserDetails', netsUserDetails);
